export default __webpack_public_path__ + "static/media/electric-towers.3702521a.jpg";